import { InjectionToken } from '@angular/core';
import { BuyProductGateway } from '@prlw/core/buy-product/buy-product-gateway.interface';

export const BUY_PRODUCT_GATEWAY = new InjectionToken<BuyProductGateway>(
  'buy-product-gateway',
);
